const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20texture%20with%20coral%20tones%2C%20simple%20minimal%20circle%20shape%2C%20soft%20gradient&width=80&height=80&seq=cmt-avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个站更新太快了！比我在微博上刷到的还快，51吃瓜和17c的内容这里都有，真正的吃瓜一站式。编辑真的24小时不睡觉吗哈哈哈哈',
    likes: 1283,
    tag: '铁杆瓜友',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20texture%20circle%2C%20soft%20minimal%20design%2C%20gentle%20gradient&width=80&height=80&seq=cmt-avatar-02&orientation=squarish',
    name: '深夜吃瓜人',
    time: '5小时前',
    content: '说实话比那些乱七八糟的爆料号靠谱多了，至少会标注可信度。昨晚那个顶流塌房的追踪报道看得我停不下来，期待更多深扒内容！',
    likes: 967,
    tag: '忠实读者',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20coral%20gradient%20circle%2C%20minimal%20soft%20texture%2C%20clean%20design&width=80&height=80&seq=cmt-avatar-03&orientation=squarish',
    name: '娱乐圈观察员',
    time: '8小时前',
    content: '作为在娱乐圈工作的业内人士，这个站的信息整合能力真的很强。虽然有些爆料需要进一步核实，但整体的时效性和覆盖面在同类站点里绝对是顶尖水平。',
    likes: 756,
    tag: '业内人士',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">吃瓜热评</h2>
          <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full font-semibold whitespace-nowrap">瓜友说</span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10 pl-4">百万吃瓜群众的真实声音，来看看大家都在讨论什么</p>

        <div className="space-y-4">
          {comments.map((cmt, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden shrink-0">
                  <img src={cmt.avatar} alt="" className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-sm font-semibold text-foreground-900">{cmt.name}</span>
                    <span className="text-xs bg-accent-100 text-accent-700 px-1.5 py-0.5 rounded-full whitespace-nowrap">{cmt.tag}</span>
                    <span className="text-xs text-foreground-500">{cmt.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">{cmt.content}</p>
                  <div className="flex items-center gap-4">
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500 cursor-pointer hover:text-primary-600 transition-colors">
                      <i className="ri-thumb-up-line"></i>
                      {cmt.likes.toLocaleString()}
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500 cursor-pointer hover:text-primary-600 transition-colors">
                      <i className="ri-chat-1-line"></i>
                      回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}